// extracted by mini-css-extract-plugin
export default {"custom__avatar":"custom__avatar__na3ue","xxlarge":"xxlarge__ybrR2"};